<!--
  画面名：-
  概要： 保存完了ダイアログコンポーネント
  備考： 保存以外の処理でも使用
-->

<!-- HTML -->
<template>
  <v-dialog content-class="changePassWrapper" v-model="isDialog" persistent max-width="400px">
    <!-- 保存ボタンを押下された際に、表示されるダイアログの要素 -->
    <v-card>
      <!-- ダイアログのタイトル -->
      <v-card-title>
        <span v-if="!msg" class="headline">{{$language.MsgDoneSave}}</span>
        <span v-if="msg">{{msg}}</span>
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <!-- 確認ボタン -->
        <v-btn color="blue darken-1" flat @click="closeDialog">{{$language.LabelConfirmation}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<!-- /HTML -->

<script>

export default {
  props: {
    // メッセージを受け取り
    msg: { type: String, default: '' }
  },
  data () {
    return {
      // ダイアログの表示切替用
      isDialog: false,
      // 画面遷移判定フラグ true:その場で閉じる false: 設定した画面へ遷移
      isClose: true,
      // どのページに遷移するか設定
      nextPage: ''
    }
  },
  watch: {
    isDialog (value) {
      // 閉じたことを親に通達
      if (!value) {
        this.$emit('close')
      }
    }
  },
  methods: {
    // ダイアログ表示機能
    openDialog (nextPage, isClose) {
      // パラメータ設定
      this.nextPage = nextPage
      this.isClose = isClose
      // ダイアログの表示をON
      this.isDialog = true
    },
    // ダイアログを閉じる機能
    closeDialog () {
      // ダイアログの表示をOFF
      this.isDialog = false
      if (!this.isClose) {
        // ページ遷移時
        this.$router.push({ name: this.nextPage })
      }
      this.$emit('set')
    }
  }
}
</script>
